<template>
  <div>
  <el-dialog :visible.sync="dialogVisible" :before-close="doClose" width="40%" top="5%" class="abow_dialog"
             :modal-append-to-body="false">
  <div class="report-customization">
    <el-form ref="form">
      <el-form-item label="">
        <el-checkbox v-model="baseInfoEnabled" :disabled="true">报告基础信息:客户、工程师，合同类型……</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="statInfoEnabled" :disabled="true">报告运行数据统计类信息:运行时间，加载时间，加载率，利用率</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="alertInfoEnabled">报告运行告警信息:告警数量（Trip/Warning）,Top3 告警内容</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="energySensorEnabled">加装能源传感器</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="vibrationSensorEnabled">加装振动传感器：从S3导入</el-checkbox>
        <el-button type="primary" @click="importDialog('vibrationSensor')" class="report-button">报告导入按钮</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="insightsEnabled">报告运行Insights 信息</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="serviceInfoEnabled">报告运行服务信息：派工记录，工单总结SFA</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="sparePartInfoEnabled">报告运行备件信息：备件更换记录SFA</el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="externalImportEnabled">油品/振动/水样，外部导入</el-checkbox>
        <el-button type="primary" @click="importDialog('oilVibrationWatersamples')" class="report-button">报告导入按钮</el-button>
      </el-form-item>
      <el-button type="success"
                 @click="reviewReport"
                 class="report-button">报告生成</el-button>
    </el-form>
  </div>
  </el-dialog>

    <!-- Import Dialog -->
    <el-dialog
        title="文件导入"
        :visible.sync="showFileImportDialog"
        width="30%"
        height="50%"
        @close="resetForm"
        ref="fileImportDialog"
        :modal="false"
    >
      <el-form ref="importForm" :model="importForm" label-width="80px">
        <el-form-item label="文件名">
          <el-input v-model="importForm.fileName"></el-input>
        </el-form-item>
        <el-form-item label="文件描述">
          <el-input v-model="importForm.fileDescription"></el-input>
        </el-form-item>
        <el-form-item label="选择文件">
          <el-upload
              ref="upload"
              action=""
              :on-change="handleFileChange"
              :before-remove="beforeRemove"
              list-type="picture"
              :auto-upload="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancelUpload">取消</el-button>
          <el-button type="primary" @click="submitUpload">上传</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import axios, { axiosDelete, get, post, put } from '../../../utils/http';
import bus from "./bus";

export default {
  data() {
    return {
      dialogVisible: false,
      baseInfoEnabled: true,
      statInfoEnabled: true,
      alertInfoEnabled: false,
      energySensorEnabled: false,
      vibrationSensorEnabled: false,
      insightsEnabled: false,
      serviceInfoEnabled: false,
      sparePartInfoEnabled: false,
      externalImportEnabled: false,
      showFileImportDialog: false,
      reportType: "",
      importForm: {
        fileName: '',
        fileDescription: '',
        file: null
      }
    };
  },
  props: {
    dsn: "",
    healthReportId: "",
    cycle: "",
    gsn:"",
    cycleType: "",
    isCustomer: false
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.dialogVisible = false;
    },
    importDialog(reportType) {
      this.showFileImportDialog = true;
      this.reportType = reportType;
      this.$nextTick(() => {
        this.$refs.fileImportDialog.$el.querySelector('input').focus(); // 手动设置焦点
      });
    },
    reviewReport() {
      console.log('Report generation button clicked');
      let reportConfig = {
        ...this.$data,
        dsn: this.dsn,
        gsn:this.gsn,
        healthReportId: this.healthReportId,
        cycleType: this.cycleType,
        cycle: this.cycle
      };
      this.$emit("reviewReport", "reviewReport");
      //this.$nextTick(() => {bus.$emit('reportConfig', reportConfig);})
      let path = null;
      if (this.isCustomer) {
        path = '/customerHealthReport'
      } else {
        path = `/healthReport2`;
      }

      const { href } = this.$router.resolve({
        path: path,
        query: reportConfig
      });
      window.open(href, '_blank');

      this.doClose();
    },
    resetForm() {
      this.importForm = {
        fileName: '',
        fileDescription: '',
        file: null
      };
    },
    handleFileChange(file) {
      this.importForm.file = file.raw;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    cancelUpload() {
      this.showFileImportDialog = false;
      this.resetForm();
    },
    submitUpload() {
      if (!this.importForm.fileName || !this.importForm.file) {
        this.$message.error('请填写文件名并选择文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.importForm.file);
      formData.append('fileName', this.importForm.fileName);
      formData.append('reportType', this.reportType);
      formData.append('dsn', this.dsn);
      formData.append('fileDescription', this.importForm.fileDescription);
      formData.append('healthReportId', this.healthReportId);

      axios.post('/api/services/app/HealthReportService/UploadReportFile', formData)
          .then(response => {
            console.log('File uploaded successfully:', response.data);
            this.showFileImportDialog = false;
            this.resetForm();
          })
          .catch(error => {
            console.error('Error uploading file:', error);
            this.resetForm();
          });


      this.showFileImportDialog = false;
      this.resetForm();
    }
  }
};
</script>

<style scoped>
.report-customization {
  background-color: #000;
  color: #fff;
  display: flex;
}

.el-form {
  height: auto; /* 自适应高度 */
  overflow-y: auto; /* 内容溢出时显示滚动条 */
}

.dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px; /* 添加内边距 */
  z-index: 1; /* 确保在最上层 */
}

.el-form-item__label {
  color: #fff;
}

.el-form-item {
  margin-left: 10px;
}

.el-checkbox__inner {
  border-color: #fff;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #fff;
  background-color: #fff;
}

.el-checkbox__input.is-checked .el-checkbox__inner::after {
  border-color: #000;
}

.el-button {
  color: #fff;
  border-color: #fff;
}

.report-button {
  margin: 10px;
}
.el-dialog__wrapper .el-dialog {
  z-index: 2001 !important; /* 确保内层弹窗在最上层 */
}

.el-dialog {
  display: flex;
  flex-direction: column;
}
.el-dialog__body {
  flex: 1; /* 内容区域自适应高度 */
  overflow-y: auto; /* 内容溢出时显示滚动条 */
}


</style>
